var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPublicBathroomIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 6,
    fill: "#005682"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2054_1033)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 6C12 5.445 12.445 5 13 5C13.555 5 14 5.445 14 6C14 6.555 13.555 7 13 7C12.445 7 12 6.555 12 6ZM14 15V12H15.25L13.98 8.185C13.84 7.775 13.46 7.5 13.03 7.5H12.97C12.54 7.5 12.155 7.775 12.02 8.185L11.59 9.475C12.13 9.775 12.5 10.34 12.5 11V15H14ZM10.25 9.75C10.665 9.75 11 9.415 11 9C11 8.585 10.665 8.25 10.25 8.25C9.835 8.25 9.5 8.585 9.5 9C9.5 9.415 9.835 9.75 10.25 9.75ZM6.75 7C7.305 7 7.75 6.555 7.75 6C7.75 5.445 7.305 5 6.75 5C6.195 5 5.75 5.445 5.75 6C5.75 6.555 6.195 7 6.75 7ZM7.75 15V11.5H8.5V8.5C8.5 7.95 8.05 7.5 7.5 7.5H6C5.45 7.5 5 7.95 5 8.5V11.5H5.75V15H7.75ZM11 15V13H11.5V11C11.5 10.59 11.16 10.25 10.75 10.25H9.75C9.34 10.25 9 10.59 9 11V13H9.5V15H11Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2054_1033"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(4 4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPublicBathroomIcon);
export default __webpack_public_path__ + "static/media/public_bathroom_icon.bf3693bf8b6206afe7b10ad244946458.svg";
export { ForwardRef as ReactComponent };